import { useQuery } from '@tanstack/react-query';
import { schedulerMonitorApi } from '../api/schedulerMonitorApi';

/**
 * GET /scheduler-monitor/batch/executions/{executionId} — 배치 실행 상세 (SCHEDULER_READ)
 * queryKey: ['scheduler-monitor', 'batch-execution', executionId]
 */
export function useBatchExecution(executionId: number | null) {
  return useQuery({
    queryKey: ['scheduler-monitor', 'batch-execution', executionId],
    queryFn: () => schedulerMonitorApi.getBatchExecution(executionId!),
    enabled: executionId !== null,
    staleTime: 60_000,
  });
}
